import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=4894e311&scoped=true"
import script from "./ResultTable.vue?vue&type=script&lang=js"
export * from "./ResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894e311",
  null
  
)

export default component.exports